import api from "./api";

const SkillService = {
  getByCategory: async (args) => {
    const { data } = await api.get(`/api/skills/?category=${args.skillCategoryId}`);
    return data;
  },

  insert: async (args) => {
    const body = {
      name: args.name,
      category: args.categoryId,
    };

    const { data } = await api.post("/api/skills/", body);
    return data;
  },
};

export default SkillService;
